import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d30bddc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-details-information mb-0" }
const _hoisted_2 = { class: "level actions mb-2 is-hidden-touch" }
const _hoisted_3 = { class: "level-left" }
const _hoisted_4 = { class: "level-item" }
const _hoisted_5 = { class: "has-text-success has-text-weight-semibold is-size-4 pl-1" }
const _hoisted_6 = { class: "level-right" }
const _hoisted_7 = { class: "level-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-pencil" }, null, -1 /* HOISTED */))
const _hoisted_9 = { class: "level-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-download" }, null, -1 /* HOISTED */))
const _hoisted_11 = { class: "columns is-multiline device-info-content m-0" }
const _hoisted_12 = { class: "column is-8-widescreen is-8-desktop is-12-touch" }
const _hoisted_13 = { class: "columns is-multiline" }
const _hoisted_14 = { class: "column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen" }
const _hoisted_15 = { class: "device-info" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-tag is-size-5 mr-1" })
], -1 /* HOISTED */))
const _hoisted_17 = { class: "has-text-weight-semibold mr-2" }
const _hoisted_18 = { class: "device-info" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-archive-cog is-size-5 mr-1" })
], -1 /* HOISTED */))
const _hoisted_20 = { class: "has-text-weight-semibold mr-2" }
const _hoisted_21 = { class: "device-info" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-barcode-scan is-size-5 mr-1" })
], -1 /* HOISTED */))
const _hoisted_23 = { class: "has-text-weight-semibold mr-2" }
const _hoisted_24 = { class: "device-info" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-card-account-details is-size-5 mr-1" })
], -1 /* HOISTED */))
const _hoisted_26 = { class: "has-text-weight-semibold mr-2" }
const _hoisted_27 = { class: "device-info" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-history is-size-5 mr-1" })
], -1 /* HOISTED */))
const _hoisted_29 = { class: "has-text-weight-semibold mr-2" }
const _hoisted_30 = { class: "column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen" }
const _hoisted_31 = { class: "device-info" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-timeline-text is-size-5 mr-1" })
], -1 /* HOISTED */))
const _hoisted_33 = { class: "has-text-weight-semibold mr-2" }
const _hoisted_34 = { class: "column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen" }
const _hoisted_35 = { class: "device-info" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-road is-size-5 mr-1" })
], -1 /* HOISTED */))
const _hoisted_37 = { class: "has-text-weight-semibold mr-2" }
const _hoisted_38 = { class: "device-info" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-city is-size-5 mr-1" })
], -1 /* HOISTED */))
const _hoisted_40 = { class: "has-text-weight-semibold mr-2" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "device-info" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-square-rounded-outline is-size-5 mr-1" })
], -1 /* HOISTED */))
const _hoisted_45 = { class: "has-text-weight-semibold mr-2" }
const _hoisted_46 = { class: "device-info" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-flag is-size-5 mr-1" })
], -1 /* HOISTED */))
const _hoisted_48 = { class: "has-text-weight-semibold mr-2" }
const _hoisted_49 = { class: "device-info" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-map-marker is-size-5 mr-1" })
], -1 /* HOISTED */))
const _hoisted_51 = { class: "has-text-weight-semibold mr-2" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "column information-map is-12-mobile is-12-tablet is-4-desktop is-4-widescreen" }
const _hoisted_55 = {
  key: 1,
  class: "h-100 w-100 center no-localisation"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-map-marker-off is-size-3" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_n_tag = _resolveComponent("n-tag")!
  const _component_n_ellipsis = _resolveComponent("n-ellipsis")!
  const _component_avolta_map = _resolveComponent("avolta-map")!
  const _component_station_edition_modal = _resolveComponent("station-edition-modal")!
  const _component_export_data_modal = _resolveComponent("export-data-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('device_details.information.title')), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_n_button, {
            class: "has-text-white",
            strong: "",
            secondary: "",
            round: "",
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs?.modal?.editStation(_ctx.station)))
          }, {
            icon: _withCtx(() => [
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(_ctx.$t('global.edit')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_n_button, {
            class: "has-text-white",
            strong: "",
            secondary: "",
            round: "",
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$refs.export.open();})
          }, {
            icon: _withCtx(() => [
              _hoisted_10
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(_ctx.$t('global.export')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                trigger: _withCtx(() => [
                  _hoisted_16
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('device_details.information.status_label')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('device_details.information.status_label')) + ":", 1 /* TEXT */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alarms, (alarm) => {
                return (_openBlock(), _createBlock(_component_n_tag, {
                  class: "mr-1",
                  key: alarm.name,
                  round: "",
                  size: "small",
                  color: { color: alarm.color, textColor: 'white'},
                  type: alarm.name === _ctx.AvoltaAlarmEnum.CH4_concentration_alarm ? 'error': 'warning'
                }, {
                  default: _withCtx(() => [
                    _createCommentVNode(" <template #icon>\n                                    <span class=\"is-size-7\" :class=\"alarm?.icon\"></span>\n                                </template> "),
                    _createTextVNode(_toDisplayString(alarm?.short), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color", "type"]))
              }), 128 /* KEYED_FRAGMENT */)),
              (_ctx.alarms.length === 0)
                ? (_openBlock(), _createBlock(_component_n_tag, {
                    key: 0,
                    round: "",
                    size: "small",
                    color: { color: _ctx.greenColor, textColor: 'white'},
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('global.ok')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["color"]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                trigger: _withCtx(() => [
                  _hoisted_19
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('device_details.information.hardware_label')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('device_details.information.hardware_label')) + ":", 1 /* TEXT */),
              _createElementVNode("span", null, _toDisplayString(_ctx.station?.hardware || '-'), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                trigger: _withCtx(() => [
                  _hoisted_22
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('device_details.information.serial_label')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('device_details.information.serial_label')) + ":", 1 /* TEXT */),
              _createElementVNode("span", null, _toDisplayString(_ctx.station?.serial || '-'), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                trigger: _withCtx(() => [
                  _hoisted_25
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('device_details.information.eid_description')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('device_details.information.eid_label')) + ":", 1 /* TEXT */),
              _createElementVNode("span", null, _toDisplayString(_ctx.station?.eid || '-'), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                trigger: _withCtx(() => [
                  _hoisted_28
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('device_details.information.last_seen_label')) + " " + _toDisplayString(_ctx.station?.last_seen ? _ctx.moment(_ctx.station?.last_seen * 1000).format('LLL') : '-'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('device_details.information.last_seen_label')) + ":", 1 /* TEXT */),
              _createElementVNode("span", null, _toDisplayString(_ctx.station?.last_seen ? _ctx.moment(_ctx.station?.last_seen * 1000).fromNow() : '-'), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                trigger: _withCtx(() => [
                  _hoisted_32
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('device_details.information.installation_label')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('device_details.information.installation_label')) + ":", 1 /* TEXT */),
              _createElementVNode("span", null, _toDisplayString(_ctx.installation?.format('ll')|| '-'), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createCommentVNode(" ADDRESS "),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                trigger: _withCtx(() => [
                  _hoisted_36
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('device_details.information.address_label')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('device_details.information.address_label')) + ":", 1 /* TEXT */),
              _createVNode(_component_n_ellipsis, { style: {"width":"100%"} }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.station?.metadata?.['elichens/public/address']|| '-'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _createCommentVNode(" CITY "),
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                trigger: _withCtx(() => [
                  _hoisted_39
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('device_details.information.city_label')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('device_details.information.city_label')) + ":", 1 /* TEXT */),
              (_ctx.station?.metadata?.['elichens/public/locality'])
                ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.station?.metadata?.['elichens/public/locality']) + " (" + _toDisplayString(_ctx.station?.metadata?.['elichens/public/postcode']) + ")", 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("span", _hoisted_42, "-"))
            ]),
            _createCommentVNode(" STATE "),
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                trigger: _withCtx(() => [
                  _hoisted_44
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('device_details.information.state_label')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('device_details.information.state_label')) + ":", 1 /* TEXT */),
              _createElementVNode("span", null, _toDisplayString(_ctx.station?.metadata?.['elichens/public/state']|| '-'), 1 /* TEXT */)
            ]),
            _createCommentVNode(" COUNTRY "),
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                trigger: _withCtx(() => [
                  _hoisted_47
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('device_details.information.country_label')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t('device_details.information.country_label')) + ":", 1 /* TEXT */),
              _createElementVNode("span", null, _toDisplayString(_ctx.station?.metadata?.['elichens/public/country']|| '-'), 1 /* TEXT */)
            ]),
            _createCommentVNode(" COORDINATES "),
            _createElementVNode("div", _hoisted_49, [
              _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                trigger: _withCtx(() => [
                  _hoisted_50
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('device_details.information.coordinates_label')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t('device_details.information.coordinates_label')) + ":", 1 /* TEXT */),
              (_ctx.station?.location?.lat && _ctx.station?.location?.lon)
                ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.station?.location?.lat?.toFixed(4)) + ", " + _toDisplayString(_ctx.station?.location?.lon?.toFixed(4)), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("span", _hoisted_53, "-"))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_54, [
        (_ctx.station && _ctx.station?.location?.lat && _ctx.station?.location?.lon)
          ? (_openBlock(), _createBlock(_component_avolta_map, {
              key: 0,
              stations: [_ctx.station],
              class: "h-100"
            }, null, 8 /* PROPS */, ["stations"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_55, [
              _hoisted_56,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('details.station_not_localized')), 1 /* TEXT */)
            ]))
      ])
    ]),
    _createVNode(_component_station_edition_modal, {
      onSubmitted: _ctx.onStationUpdated,
      ref: "modal"
    }, null, 8 /* PROPS */, ["onSubmitted"]),
    (_ctx.station)
      ? (_openBlock(), _createBlock(_component_export_data_modal, {
          key: 0,
          ref: "export",
          since: _ctx.since,
          before: _ctx.before,
          stations: [_ctx.station]
        }, null, 8 /* PROPS */, ["since", "before", "stations"]))
      : _createCommentVNode("v-if", true)
  ]))
}